import ApprovedDecision from "components/card/approved-decision/ApprovedDecision";
import ApplicationContainer from "components/application-container/ApplicationContainer";
import { useQuote, useMarkApplicationSubmitted } from "hooks";
import { useContactInformation } from "hooks/useContactInformation";

const SuccessDecisionPage = () => {
    const { quoteData } = useQuote();
    const { contactData } = useContactInformation();

    // Terminal page: flag the submission and clear the persisted snapshot
    // (in-memory data stays available for rendering below)
    useMarkApplicationSubmitted();

    return (
        <>
            <title>Approved | AAA Life</title>
            <ApplicationContainer elementId="success-decision-content" isPrintable>
                <ApprovedDecision
                    productName="Direct Term Life Insurance"
                    firstName={contactData?.contactInformation?.firstName ?? ""}
                    selectedCoverageAmount={quoteData?.selectedCoverageAmount ?? 0}
                    selectedCoveragePremium={quoteData?.selectedCoveragePremium ?? 0.0}
                    policyNumber={contactData?.policyNumber ?? ""}
                />
            </ApplicationContainer>
        </>
    );
};

export default SuccessDecisionPage;
